/**
 * Home Component Constants
 * Centralized configuration for home navigation and API endpoints
 */

// API Endpoints
export const API_ENDPOINTS = {
  PANELS: '/Panels/SelectOptions',
  CATEGORIES_BY_PANEL: '/Categories/SelectOptionsByPanel',
  SUBCATEGORIES_BY_CATEGORY: '/Subcategories/ByCategory',
  TOOLS_BY_SUBCATEGORY: '/ToolPassports/BySubcategory',
  TOOL_PASSPORT_DETAIL: '/ToolPassports',
  TOOL_SELECTION_OPTIONS: '/ToolPassports/SelectOptionsBySubcategory',
};

// Route Paths
export const HOME_ROUTES = {
  HOME: '/Home',
  PANELS: '/HomePanels',
  CATEGORIES: '/HomeCategories',
  SUBCATEGORIES: '/HomeSubcategories',
  TOOLS: '/HomeTools',
  TOOL_SELECTION: '/ToolSelection/Selection',
  // Legacy routes (for backward compatibility)
  LEGACY_TOOLS: '/Tools',
};

// Translation Keys
export const HOME_TRANSLATIONS = {
  WELCOME_TITLE: 'welcome.cadcom',
  WELCOME_DESC: 'welcome.description',
  PANEL: 'common.panel',
  CATEGORY: 'common.category',
  SUBCATEGORY: 'common.subcategory',
  TOOL: 'common.tool',
  VIEW_PASSPORT: 'tools.viewPassport',
  LOADING: 'common.loading',
  NO_DATA: 'common.noData',
  ERROR_LOADING: 'errors.loadingData',
  CHOOSE_PANEL: 'home.choosePanel',
  CHOOSE_CATEGORY: 'home.chooseCategory',
  CHOOSE_SUBCATEGORY: 'home.chooseSubcategory',
  GO_TO_SELECTION: 'tools.goToSelection',
};

// Default fallback image path
export const DEFAULT_LOGO = '/assets/brand/default_img.png';
export const FALLBACK_LOGO = '/default-logo.png';

// Card dimensions and styling constants
export const CARD_CONFIG = {
  MAX_WIDTH: '28rem',
  MIN_HEIGHT: '10rem',
  LOGO_WIDTH: '75px',
  LOGO_HEIGHT: '50px',
};

// Error Messages
export const ERROR_MESSAGES = {
  LOAD_PANELS: 'Cannot load panels',
  LOAD_CATEGORIES: 'Cannot load categories',
  LOAD_SUBCATEGORIES: 'Cannot load subcategories',
  LOAD_TOOLS: 'Cannot load tools',
  LOAD_TOOL_DETAIL: 'Cannot load tool passport details',
};

// Empty state responses from API
export const API_EMPTY_RESPONSE = 'No records';
